<template>
  <th
    v-bind="$attrs"
    class="sortable-head"
    @click="$emit('sort', sortKey)"
  >
    <div class="sortable-head-inner">
      <span><slot /></span>
      <span class="sortable-icons">
        <i
          v-if="isActive && dir === 'asc'"
          class="bi bi-arrow-up sort-icon active"
        />
        <i
          v-else
          class="bi bi-arrow-down sort-icon"
          :class="{ active: isActive && dir === 'desc' }"
        />
      </span>
    </div>
  </th>
</template>

<script>
export default {
  name: 'SortableTh',

  inheritAttrs: false,

  props: {
    sortKey: {type: String, required: true},
    activeKey: {type: String, default: null},
    dir: {type: String, default: 'desc'},
  },

  computed: {
    isActive() {
      return this.activeKey === this.sortKey;
    },
  },
};
</script>

<style scoped>
.sortable-head {
  cursor: pointer;
  user-select: none;
}

.sortable-head:hover {
  background: #f8fafc !important;
}

.sortable-head-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.sortable-icons {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
  opacity: 0.7;
}

.sort-icon {
  font-size: 10px;
  color: #94a3b8;
  opacity: 0.4;
  transition: color 0.15s ease, opacity 0.15s ease;
}

.sortable-head:hover .sort-icon {
  opacity: 0.7;
}

.sort-icon + .sort-icon {
  margin-top: -2px;
}

.sort-icon.active {
  color: #111827;
  opacity: 1;
}
</style>
